<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="所属账号">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择管理员" labelName="userName"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                               placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                               dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                               queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item
                  label="银行卡类"
              >
                  <el-select
                      style="width:177px"
                      v-model="queryForm.cardType"
                      size="small"
                      placeholder="请选择"
                      :disabled="mppBankCardState == 'check'"
                  >
                      <el-option
                          v-for="(item,index) in bankCardTypeEnumList"
                          :key="index"
                          :label="item.value"
                          :value="item.key"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="银行名称">
                  <el-input style="width:177px" v-model="queryForm.bankName"></el-input>
              </el-form-item>
              <el-form-item label="银行简称">
                  <el-input style="width:177px" v-model="queryForm.bankCode"></el-input>
              </el-form-item>
              <el-form-item label="银行卡号">
                  <el-input style="width:177px" v-model="queryForm.bankCard"></el-input>
              </el-form-item>
              <el-form-item label="持有人名">
                  <el-input style="width:177px" v-model="queryForm.cardHolder"></el-input>
              </el-form-item>
              <el-form-item
                  label="是否默认"
              >
                  <el-select
                      style="width:177px"
                      v-model="queryForm.isDefault"
                      size="small"
                      placeholder="请选择"
                      :disabled="mppBankCardState == 'check'"
                  >
                      <el-option
                          label="否"
                          :value="0"
                      > </el-option>
                      <el-option
                          label="是"
                          :value="1"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppBankCardList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppBankCard"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppBankCard(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppBankCard(null)"
        >删除</el-button>
          <el-button
              type='primary'
              plain
              size='small'
              @click='getBank()'
          >银行管理
          </el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMppBankCardList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMppBankCardList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      height='100%'
      :data="mppBankCardList"
      row-key="id"
      border
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="user.userName"
        label="所属用户"
        width="180"
      > 
      <template slot-scope="scope">
            <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="cardType"
            label="银行卡类型"
            width="180"
        >
            <template slot-scope='scope'>
                <div>{{computeBankCardType(scope.row.cardType)}}</div>
            </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="bankName"
            label="银行名称"
            width="180"
        > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="bankCode"
        label="银行简称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="bankCard"
        label="银行卡号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardHolder"
        label="持有人名"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isDefault"
        label="是否默认"
        width="180"
      >
          <template scope='scope'>
              <div v-if='scope.row.isDefault'>是</div>
              <div v-if='!scope.row.isDefault'>否</div>
          </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppBankCard(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppBankCard(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppBankCard(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppBankCardStates[mppBankCardState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppBankCard"
          ref="mppBankCardForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="所属账号"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mppBankCard.userId"-->
<!--              :disabled="mppBankCardState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择管理员" labelName="userName"
                           :disabled="mppBankCardState == 'check'"
                           labelValue="id" :value="mppBankCard.userId" :limit='1' size='small'
                           placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search"
                           dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                           queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
            <el-form-item
                label="银行名称"
                prop="bankName"
            >
                <el-input
                    size="small"
                    style="width:177px"
                    v-model="mppBankCard.bankName"
                    :disabled="mppBankCardState == 'check'"
                ></el-input>
            </el-form-item>
          <el-form-item
            label="银行简称"
            prop="bankCode"
          >
            <el-input
              size="small"
              style="width:177px"
              v-model="mppBankCard.bankCode"
              :disabled="mppBankCardState == 'check'"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="银行卡号"
            prop="bankCard"
          >
            <el-input
              size="small"
              style="width:177px"
              v-model="mppBankCard.bankCard"
              :disabled="mppBankCardState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="持有人名"
            prop="cardHolder"
          >
            <el-input
              size="small"
              style="width:177px"
              v-model="mppBankCard.cardHolder"
              :disabled="mppBankCardState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
                label="是否默认"
                prop="isDefault"
            >
                <el-select
                    style="width:177px"
                    v-model="mppBankCard.isDefault"
                    size="small"
                    placeholder="请选择"
                    :disabled="mppBankCardState == 'check'"
                >
                    <el-option
                        label="否"
                        :value="0"
                    > </el-option>
                    <el-option
                        label="是"
                        :value="1"
                    > </el-option>
                </el-select>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppBankCardState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
      <el-drawer
          title="银行管理"
          :visible.sync="showBank"
          direction="rtl"
          size="60%"
          :destroy-on-close="true"
          :show-close="true"
          :wrapperClosable="true"
          @close="closeBank"
      >
          <Bank></Bank>
      </el-drawer>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import Bank from '@/views/system/Bank.vue';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        Bank
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppBankCardList();
                    this.getMppBankCardList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppBankCardList();
                    this.getMppBankCardList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                bankCardTypeEnumList: [],
                USER_code: USER,
                USER_search: USER_SEARCH,
                queryForm:{
                     userId: '', //用户id
                     cardType: '', //银行卡类型
                     bankCode: '', //银行简称
                     bankName: '', //银行名称
                     bankCard: '', //银行卡
                     cardHolder: '', //持有人名称
                     isDefault: '', //是否默认
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppBankCardState: 'add',
                mppBankCardStates: {
                    add: '新建银行卡',
                    check: '查看银行卡',
                    edit: '修改银行卡'
                },

                showBank: false,

                multipleSelection: [],
                mppBankCardList: [],
                mppBankCard: {
                    userId: '', //用户id
                    cardType: '', //银行卡类型
                    bankCode: '', //银行简称
                    bankName: '', //银行名称
                    bankCard: '', //银行卡
                    cardHolder: '', //持有人名称
                    isDefault: 1, //是否默认
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '所属账号不能为空', trigger: 'blur' }],
                    bankCode: [{ required: true, message: '银行简称不能为空', trigger: 'blur' }],
                    bankName: [{ required: true, message: '银行名称不能为空', trigger: 'blur' }],
                    bankCard: [{ required: true, message: '银行卡号不能为空', trigger: 'blur' }],
                    cardHolder: [{ required: true, message: '持有人名不能为空', trigger: 'blur' }],
                    isDefault: [{ required: true, message: '是否默认不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMppBankCardList();
            this.getBankCardTypeEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser(value) {
                this.mppBankCard.userId = value;
            },
            getSearchValueUser(value) {
                this.queryForm.userId = value;
            },
            resetMppBankCardList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppBankCardList = [];
            },
            getBank(){
                this.showBank = true;
            },
            closeBank(){
                this.showBank = false;
            },
            resetDialog() {

                this.mppBankCardState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户id
                      cardType: '', //银行卡类型
                      bankCode: '', //银行简称
                      bankName: '', //银行名称
                      bankCard: '', //银行卡
                      cardHolder: '', //持有人名称
                      isDefault: '', //是否默认
                };
                this.getMppBankCardList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppBankCard = {
                      userId: '', //用户id
                      cardType: '', //银行卡类型
                      bankCode: '', //银行简称
                      bankName: '', //银行名称
                      bankCard: '', //银行卡
                      cardHolder: '', //持有人名称
                      isDefault: '', //是否默认
                };
            },
            submitForm() {
                if (this.mppBankCardState == 'add') {
                    this.$refs.mppBankCardForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/bankcard/add`,{ ...this.mppBankCard }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppBankCardList();
                                    this.resetDialog();
                                    this.getMppBankCardList();
                                }
                            });
                        }
                    });
                } else if (this.mppBankCardState == 'edit') {
                    this.$refs.mppBankCardForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mppBankCard.user
                            post(`/mpp/bankcard/edit`,{ ...this.mppBankCard }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    console.log(res)
                                    this.resetMppBankCardList();
                                    this.resetDialog();
                                    this.getMppBankCardList();
                                }
                            });
                        }
                    });
                }
            },
            addMppBankCard() {
                this.mppBankCard = {
                    userId: '', //用户id
                    cardType: '', //银行卡类型
                    bankCode: '', //银行简称
                    bankName: '', //银行名称
                    bankCard: '', //银行卡
                    cardHolder: '', //持有人名称
                    isDefault: 1, //是否默认
                },
                this.showDialog = true;
                this.mppBankCardState = 'add';
            },
            checkMppBankCard(mppBankCardId) {
                console.log('mppBankCardId',mppBankCardId);
                this.currentMppBankCardId = mppBankCardId;

                this.getMppBankCardById();
                this.showDialog = true;
                this.mppBankCardState = 'check';
            },
            editMppBankCard(mppBankCardId) {
                console.log('mppBankCard', mppBankCardId);
                if (mppBankCardId) {
                    this.currentMppBankCardId = mppBankCardId;
                    this.getMppBankCardById();
                } else {
                    this.mppBankCard = { ...this.mppBankCard, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppBankCardState = 'edit';
            },
            deleteMppBankCard(mppBankCardId) {
                let ids = '';
                if (mppBankCardId) {
                    ids = mppBankCardId;
                } else {
                    ids = this.multipleSelection.map((mppBankCard) => mppBankCard.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/bankcard/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppBankCardList();
                                this.getMppBankCardList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppBankCardList() {
                this.resetMppBankCardList();
                this.getMppBankCardList();
            },
            getMppBankCardList(query = {}) {
                this.loading = true;
                get(`/mpp/bankcard/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppBankCardList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getMppBankCardById() {
                get(`/mpp/bankcard/get`,{ id: this.currentMppBankCardId }).then((res) =>{
                    if(res.success){
                      this.mppBankCard = { ...this.mppBankCard,...res.mppUserBank};
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppBankCardList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/bankcard/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/bankcard/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/bankcard/importData`,formData);
              this.refreshMppBankCardList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppBankCardList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppBankCardList();
            },

            // 获取银行卡类型枚举
            getBankCardTypeEnum(){
                get('/mpp/utils/getEnum',{ enumType:'bank_card_type' }).then((res)=>{
                    if(res.success){
                        this.bankCardTypeEnumList = res.enumList
                    }
                })
            },

            // 计算银行卡类型
            computeBankCardType(key){
                for (let i = 0; i < this.bankCardTypeEnumList.length; i++) {
                    if(this.bankCardTypeEnumList[i].key == key){
                        return this.bankCardTypeEnumList[i].value
                    }
                }
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
